(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('VilleController', VilleController);

    VilleController.$inject = ['$scope', '$state', 'Ville', 'VilleSearch', 'TableService'];

    function VilleController($scope, $state, Ville, VilleSearch, TableService) {

        var vm = this;
        var addItemData = {
            templateUrl: 'app/entities/ville/ville-dialog.html',
            controller: 'VilleDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'sm',
            resolve: {
                entity: function() {
                    return {
                        nom: null,
                        id: null
                    };
                }
            }
        };



        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/ville/ville-dialog.html',
            controller: 'VilleDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/entities/ville/ville-delete-dialog.html',
            controller: 'VilleDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Ville,
            entitySearch: Ville,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();